<template lang="pug">
    cs-loader(v-if="!params")
    .settings__form(v-else)
        .settings__field
            label.settings__label
                | {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}
            .settings__field-body
                cs-checkbox.settings__button(
                    v-model="params.operations.multiply",
                    :disabled="!params.operations.divide",
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_operationMultiply') }}
                cs-checkbox.settings__button(
                    v-model='params.operations.divide',
                    :disabled="!params.operations.multiply",
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_operationDivide') }}
        .settings__field
            .settings__columns
                .settings__column
                    label.settings__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}
                    .settings__fractions
                        cs-checkbox.settings__button.settings__button_is-full-width(
                            v-model="params.fractions.left",
                            :disabled="params.numbers.length !== 0"
                        )
                            |   {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                        .select-container(v-if="params.fractions.left")
                            cs-select.select-container__select(
                                :options="2",
                                v-model="params.fractionalPart.left",
                            )
                            .select-container__label
                                span {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                    .tabs-container
                        settings-tab.settings__button.settings__button_is-tab(
                            v-for="number in numbers",
                            :key="number",
                            :selected="params.numbers && params.numbers.includes(number)",
                            @click.native.prevent="setNumber(number)",
                        ) {{ number }}
                    .tabs-container
                        settings-tab.settings__button.settings__button_is-tab(
                            v-for="(value, key) in digitCapacities",
                            :selected="params.digitCapacity.left && params.digitCapacity.left.includes(+key)",
                            @click.native.prevent="setKey('left', +key)"
                            :key="'left' + key"
                        ) {{ value }}
                .settings__column
                    label.settings__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}
                    .settings__fractions
                        cs-checkbox.settings__button.settings__button_is-full-width(
                            v-model="params.fractions.right",
                            :disabled="rightFractionsDisabled"
                        )
                            |   {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                        .select-container(v-if="params.fractions.right")
                            cs-select.select-container__select(
                                v-model='params.fractionalPart.right',
                                :options='+params.fractionalPart.left',
                            )
                            .select-container__label
                                span {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                    .tabs-container
                        settings-tab.settings__button.settings__button_is-tab(
                            v-for="(value, key) in digitCapacities",
                            :selected='params.digitCapacity.right && params.digitCapacity.right.includes(+key)',
                            @click.native.prevent="setKey('right', +key)",
                            :disabled="rightDigitCapacityDisabled(key)",
                            :key="'digitCapacities' + key"
                        )
                            | {{ value }}
                        settings-tab.settings__button.settings__button_is-tab(
                            :selected='params.tabulatedValue',
                            @click.native.prevent="params.tabulatedValue = !params.tabulatedValue",
                            :disabled="params.digitCapacity.left.length !== 0",
                            :key="'tabulatedValue' + key"
                        ) {{ $i18n.t('trainer.trainer_gameFormSetting_tableValue') }}
</template>

<script>
    export default {
        props: {
            currentUserParams: {
                type: Object,
                default() {
                    return null;
                },
            },
        },
        data() {
            return {
                params: null,
                numbers: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                digitCapacities: {
                    1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                    2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                    3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                    4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                    5: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                    6: this.$i18n.t('common.common_gameSetting_digitCapacity6'),
                    7: this.$i18n.t('common.common_gameSetting_digitCapacity7'),
                    8: this.$i18n.t('common.common_gameSetting_digitCapacity8'),
                },
            };
        },
        watch: {
            currentUserParams: {
                handler(value) {
                    this.params = value;
                },
            },
            'params.digitCapacity.left': {
                handler(val) {
                    if (val[0]) {
                        this.params.numbers = [];
                        this.params.tabulatedValue = false;
                        val[0] < this.params.digitCapacity.right[0] && (this.params.digitCapacity.right[0] = val[0]);
                    }
                },
            },
            'params.digitCapacity.right': {
                handler(val) {
                    if (val[0]) {
                        this.params.tabulatedValue = false;
                    }
                },
            },
            'params.tabulatedValue': {
                handler(val) {
                    if (val) {
                        this.params.digitCapacity.right = [];
                    }
                },
            },
            'params.numbers': {
                handler(val) {
                    if (val && val.length) {
                        this.params.fractions.left = false;
                        if (+this.params.digitCapacity.right[0] === 1) {
                            this.params.digitCapacity.right = [];
                        }
                    }
                },
            },
            rightFractionsDisabled: {
                handler(val) {
                    if (val) {
                        this.params.fractions.right = false;
                    }
                },
            },
            'params.fractions.right': {
                handler(val) {
                    if (val && this.params.tabulatedValue) {
                        this.params.tabulatedValue = false;
                    }
                },
            },
            'params.fractionalPart.left': {
                handler() {
                    this.params.fractionalPart.right = 1;
                },
            },
        },
        methods: {
            setNumber(number) {
                if (this.params.numbers.includes(number)) {
                    this.params.numbers.splice(this.params.numbers.indexOf(number), 1);
                } else {
                    this.params.numbers.push(number);
                }
                this.params.digitCapacity.left = [];
            },
            setKey(key, value) {
                if (this.params.digitCapacity[key].includes(value)) {
                    this.params.digitCapacity[key].splice(this.params.digitCapacity[key].indexOf(value), 1);
                } else {
                    this.params.digitCapacity[key] = [];
                    this.params.digitCapacity[key].push(value);
                }
            },
            rightDigitCapacityDisabled(index) {
                return (
                    (this.params.numbers.length === 0 && this.params.digitCapacity.left[0] < index) ||
                    (+index === 1 && this.params.numbers.length !== 0)
                );
            },
            isDisabled(value) {
                return this.params.numbers.length === 0 && this.params.digitCapacity.left[0] < value;
            },
        },
        computed: {
            rightFractionsDisabled() {
                return this.params && (this.params.numbers.length !== 0 || !this.params.fractions.left);
            },
        },
    };
</script>

<style scoped lang="scss">
    .settings__form {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 25px 10px 15px;
        @include media($xl) {
            padding: 25px 10px;
        }
    }
    .settings__field {
        display: flex;
        justify-content: flex-start;
        @include stack-space($space-base);
    }
    .settings__label {
        display: flex;
        align-items: center;
        font-weight: 500;
        margin-right: 20px;
        white-space: nowrap;
    }
    .settings__field-body {
        display: flex;
        align-items: center;
    }
    .settings__button {
        margin-right: 10px;
    }
    .settings__button_is-tab {
        margin-top: 10px;
    }
    .settings__button_is-full-width {
        width: 100%;
        display: flex;
        align-items: center;
    }
    .settings__columns {
        display: flex;
        width: 100%;
    }
    .settings__column {
        width: 100%;
        &:first-child {
            margin-right: 50px;
        }
    }
    .settings__fractions {
        display: flex;
        margin-top: 10px;
        min-height: 43px;
    }
    .select-container {
        display: flex;
        align-items: center;
        width: 100%;
    }
    .select-container__select {
        width: 70px;
    }
    .select-container__label {
        margin: 0 0 6px 20px;
        white-space: nowrap;
    }
    .tabs-container {
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
    }
</style>
